import React from 'react';
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

import * as styles from './CheckboxField.module.scss';

interface CheckboxFieldProps {
  topLabel?: string;
  checkboxLabel: string | React.ReactElement;
  name: string;
  disabled?: boolean;
  value: boolean | null;
  onChange: (value: boolean) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  small?: boolean;
  withErrorIcon?: boolean;
  className?: string;
}

const CheckboxField = ({
  topLabel,
  checkboxLabel,
  name,
  disabled,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  small,
  withErrorIcon,
  className,
}: CheckboxFieldProps): React.ReactElement => {
  return (
    <FormControl error={error} className={styles.container + (className ? ' ' + className : '')}>
      {topLabel && <FormLabel>{topLabel}</FormLabel>}
      <FormControlLabel
        disabled={disabled}
        control={
          <Checkbox
            color="primary"
            name={name}
            checked={!!value}
            onChange={e => onChange(e.target.checked)}
            onBlur={onBlur}
            size={small ? 'small' : 'medium'}
          />
        }
        label={checkboxLabel}
      />

      {helperText && (
        <FormHelperText>
          {withErrorIcon && <AiOutlineExclamationCircle />}
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxField;
